// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FDloc","icon":"styles_icon__np7xf","more":"styles_more__0IV5T"};